import LinkIcon from '@mui/icons-material/Link';
import { Link } from 'react-router-dom';
import { TableCardProps } from '../TableCard.types';
import styles from '../TableCard.module.css';
import { t } from 'i18next';

export const TableCardTitle = <TData extends object>({ breadcrumb, title }: TableCardProps<TData>) => (
  <div className={styles.titleLabels}>
    <div>{title}</div>
    {breadcrumb && (
      <div>
        <LinkIcon style={{ fontSize: '26px', marginRight: '.2em', color: '#266DCC' }} />
        <p className={styles.linkedBundlesLabel}>{t('common.linkedBundles')}</p>
        <div className={styles.totalDivider} />
        <Link to={breadcrumb.to} onClick={breadcrumb.onClick} id="skipNavTarget">
          {breadcrumb.label}
        </Link>
      </div>
    )}
  </div>
);
